import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { RolesService } from '@services/seguridad/roles/roles.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogDeleteRolComponent } from './dialog-delete-rol/dialog-delete-rol.component';

@Component({
  selector: 'app-eliminar-rol',
  templateUrl: './eliminar-rol.component.html',
  styleUrls: ['./eliminar-rol.component.css']
})
export class EliminarRolComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteRolComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private rolesService: RolesService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

  doAction() {
    this.delete(this.data.id)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  delete(id: number) {
    this.spinner.show("spEliminarRoles")
    this.rolesService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide("spEliminarRoles")
          this.snackBar.showSuccess("Registro eliminado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar });
        },
        error => {
          this.spinner.hide("spEliminarRoles")
          this.snackBar.showError(error, "Error");
        }
      )
  }
  trackByItems(index: number, item: any): any { return item; }
}
